import { useCallback } from 'react';

type BigMarkerEventStatus = 'conference_ended' | 'conference_setting_up' | ({} & string);

export const useGetTelehealthEventErrorMessage = () =>
  useCallback(({ type }: { type: BigMarkerEventStatus }) => {
    switch (type) {
      case 'conference_ended':
        return 'This conference has ended.';

      case 'conference_setting_up':
        return 'The event is not ready yet. Please try again later.';

      default:
        return 'Sorry, we couldn’t determine the status of this event. Please try again later.';
    }
  }, []);
